import { Box, Flex, Text, Image } from '@chakra-ui/react';

interface LogoProps {
  collapse: boolean;
}

export const Logo = ({ collapse }: LogoProps) => (
  <Flex
    w='full'
    alignItems='center'
    justifyContent='space-between'
    flexDirection={collapse ? 'row' : 'column'}
    gap={4}
    marginBottom={collapse ? "0px": "10px"}
  >
    <Box display='flex' alignItems='center' gap={2}>
      {collapse
        ? <Image src="https://benbruno.com/wp-content/uploads/2020/12/brunostrong-logo-1.png" alt='logo' maxWidth='200px'/>
        : <Image src="https://benbruno.com/wp-content/uploads/2020/12/ben-bruno-favicon.png" alt='logo' />
      }
      
      {/* LOGO
      {collapse && (
        <Text fontWeight='bold' fontSize={16}>
          Strong app
        </Text>
      )} */}
    </Box>
    
  </Flex>
);
